import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { isNullUndefined, getTranslateByKey } from "@/main/services/utils";
import { signalRClearReceiveUpdatesByKey } from "@/main/store/signalR";
import { SendUpdatesSignalRTypeEnum } from "@/main/services/enum/SendUpdatesSignalRTypeEnum";
import { SignalRBodyshopAiAnalysisResponse } from "@/main/models/common/signalRReceiveUpdatesResponse";

const PROGRESS_STATUS = {
	Start: 1,
	Success: 2,
	Failure: 3,
} as const;

interface HubItemBodyshopAiAnalysisCustomProps {
	onSuccess: () => void;
	onFailure: (message: string) => void;
}

interface HubItemBodyshopAiAnalysisProps {
	data: SignalRBodyshopAiAnalysisResponse[];
	customProps?: HubItemBodyshopAiAnalysisCustomProps;
}

const HubItemBodyshopAiAnalysis = ({ data, customProps }: HubItemBodyshopAiAnalysisProps) => {
	const dispatch = useDispatch();

	const formattedData = isNullUndefined(data) ? [] : data;

	useEffect(() => {
		if (formattedData.length === 0) return;

		const lastUpdate = formattedData[formattedData.length - 1];

		if (lastUpdate.progressStatus === PROGRESS_STATUS.Success) {
			dispatch(signalRClearReceiveUpdatesByKey(SendUpdatesSignalRTypeEnum.BodyshopAiAnalysis));
			customProps?.onSuccess();
			return;
		}

		if (lastUpdate.progressStatus === PROGRESS_STATUS.Failure) {
			const message = lastUpdate.message || getTranslateByKey("information.somethingWrong", true);
			dispatch(signalRClearReceiveUpdatesByKey(SendUpdatesSignalRTypeEnum.BodyshopAiAnalysis));
			customProps?.onFailure(message);
		}
	}, [JSON.stringify(formattedData)]);

	return <></>;
};

export default HubItemBodyshopAiAnalysis;
